import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20dramatic%20spotlight%2C%20warm%20golden%20lighting%2C%20elegant%20and%20luxurious%20atmosphere%2C%20classic%20cinema%20aesthetic%2C%20soft%20bokeh%20background%2C%20film%20projector%20light%20beams%2C%20rich%20deep%20colors&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="68影院 - 电影大全高清在线观看"
          title="68影院 电影大全 高清免费在线观看"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/60 via-foreground-900/40 to-foreground-900/70"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
          电影<span className="text-accent-400">大全</span> · 畅享<span className="text-primary-400">高清</span>视界
        </h1>
        <p className="text-sm md:text-lg text-background-200/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          68影院汇聚海量<strong className="text-accent-300">最新电影</strong>与<strong className="text-accent-300">热门电影排行榜</strong>，支持<strong className="text-primary-300">高清免费在线观看</strong>不缓冲，经典影片与最新上映一网打尽
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/action"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-play-circle-fill text-lg"></i>
            立即观影
          </Link>
          <Link
            to="/category/scifi"
            className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-fire-line text-lg"></i>
            热门推荐
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50,000+</div>
            <div className="text-xs text-background-300/70 mt-1">电影资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">800万+</div>
            <div className="text-xs text-background-300/70 mt-1">活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">98%</div>
            <div className="text-xs text-background-300/70 mt-1">用户好评</div>
          </div>
        </div>
      </div>
    </section>
  );
}